import React from 'react';
import { Autocomplete, FormControl, TextField } from '@carrotfertility/carotene-core';
import { Controller, useFormContext } from 'react-hook-form';
import { getFormInputState } from './form-utils';
import { FormAutocompleteProps, FormSelectOption } from './form-types';

export function FormAutocomplete<
    Multiple extends boolean | undefined = undefined,
    DisableClearable extends boolean | undefined = undefined,
    FreeSolo extends boolean | undefined = undefined,
>({
    name,
    helperText,
    error,
    label,
    fullWidth,
    controllerProps = {},
    ...otherProps
}: FormAutocompleteProps<FormSelectOption, Multiple, DisableClearable, FreeSolo>) {
    const {
        formState: { errors, isSubmitting },
        control,
    } = useFormContext();

    const emptyValue = otherProps?.multiple ? [] : null;

    const { error: hasError, helperText: helperTextValue } = getFormInputState({ name, errors, error, helperText });

    return (
        <FormControl error={hasError} fullWidth={fullWidth}>
            <Controller
                {...controllerProps}
                {...{ control, name }}
                render={({ field }) => (
                    <Autocomplete
                        {...field}
                        {...otherProps}
                        disablePortal
                        disabled={isSubmitting || otherProps?.disabled}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        value={field?.value ?? emptyValue}
                        onChange={(_, option) => field.onChange(option)}
                        renderInput={(params) => (
                            <TextField
                                label={label}
                                required={Boolean(controllerProps?.rules?.required)}
                                {...params}
                                helperText={helperTextValue}
                                error={hasError}
                            />
                        )}
                    />
                )}
            />
        </FormControl>
    );
}
